import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import style from './style/style';
// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';

class SweetAlertWrapper extends React.Component {
  render() {
    const {
      classes,
      danger,
      title,
      warning,
      success,
      showCancel,
      onConfirm,
      onCancel,
      confirmBtnCssClass,
      confirmBtnText,
      cancelBtnText,
      text,
    } = this.props;

    return (
      <div className={classes.sweetAlertContainer}>
        <SweetAlert
          danger={danger}
          warning={warning}
          success={success}
          title={title}
          showCancel={showCancel}
          style={{
            borderRadius: 0,
            margin: 0,
            position: 'relative',
            top: '',
            left: '',
            right: '',
            maxWidth: '100%',
          }}
          confirmBtnBsStyle='default'
          cancelBtnBsStyle='default'
          confirmBtnCssClass={confirmBtnCssClass ? confirmBtnCssClass : `${classes.button} ${classes.success}`}
          cancelBtnCssClass={`${classes.button} ${classes.danger}`}
          confirmBtnText={confirmBtnText ? confirmBtnText : 'OUI'}
          cancelBtnText={cancelBtnText ? cancelBtnText : 'ANNULER'}
          onConfirm={onConfirm}
          onCancel={onCancel}>
          {text}
        </SweetAlert>
      </div>
    );
  }
}

export default withStyles(style)(SweetAlertWrapper);
